import React, { useState, useEffect } from "react";
import { firestore } from "../../firebase-config";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";
import "../../styles/newsAndEvents.css"; // Optional: Add styles here

const NewsAndEvents = () => {
  const [news, setNews] = useState([]);
  const [newEvent, setNewEvent] = useState({ date: "", name: "", description: "" });
  const [status, setStatus] = useState(""); // To track submission status (loading, success, error)

  // Firestore collection reference
  const newsCollection = collection(firestore, "news");

  // Fetch news from Firestore
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const querySnapshot = await getDocs(newsCollection);
        const fetchedNews = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNews(fetchedNews); // Update the news state with fetched data
      } catch (err) {
        console.error("Failed to fetch news:", err);
        setStatus("error");
      }
    };

    fetchNews();
  }, []); // Fetch news only on component mount

  // Handle input change for the form
  const handleChange = (e) => {
    setNewEvent({ ...newEvent, [e.target.name]: e.target.value });
  };

  // Submit new news/event to Firestore
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading"); // Set status to loading while the request is processing

    try {
      const docRef = await addDoc(newsCollection, newEvent); // Add the new event to Firestore
      setNews([...news, { id: docRef.id, ...newEvent }]); // Update the local news state
      setNewEvent({ date: "", name: "", description: "" }); // Reset form fields
      setStatus("success"); // Set status to success after the event is added
    } catch (err) {
      console.error("Failed to add news:", err);
      setStatus("error");
    }
  };

  // Delete news/event from Firestore
  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(newsCollection, id)); // Delete the document from Firestore
      setNews(news.filter((item) => item.id !== id)); // Update the local news state
    } catch (err) {
      console.error("Failed to delete news:", err);
      alert("Error deleting news. Please try again.");
    }
  };

  return (
    <div className="news-container">
      <h2>News and Events</h2>

      {/* Form to add news */}
      <form onSubmit={handleSubmit} className="news-form">
        <input
          type="date"
          name="date"
          value={newEvent.date}
          onChange={handleChange}
          placeholder="Event Date"
          required
        />
        <input
          type="text"
          name="name"
          value={newEvent.name}
          onChange={handleChange}
          placeholder="Event Name"
          required
        />
        <textarea
          name="description"
          value={newEvent.description}
          onChange={handleChange}
          placeholder="Event Description"
          required
        ></textarea>
        <button type="submit">
          {status === "loading" ? (
            <div className="spinner"></div> // Loading spinner
          ) : status === "success" ? (
            <span className="success-icon">✔️</span> // Green tick on success
          ) : (
            "Add Event"
          )}
        </button>
      </form>

      {/* List of news/events */}
      <div className="news-list">
        {news.length === 0 ? (
          <p>No news or events available</p>
        ) : (
          news.map((item) => (
            <div key={item.id} className="news-item">
              <h3>{item.name}</h3>
              <p><strong>Date:</strong> {item.date}</p>
              <p>{item.description}</p>
              <button
                onClick={() => handleDelete(item.id)}
                className="delete-button"
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>

      {/* Status messages */}
      {status === "error" && (
        <p className="error-message">
          Error occurred while fetching or submitting data. Please try again.
        </p>
      )}
    </div>
  );
};

export default NewsAndEvents;
